import { Link } from "react-router-dom";
import useImagePreview from "../../hooks/useImagePreview";
import { CheckoutComponentImageAttibutesType } from "../../types/builder";
import CheckoutComponentAlignmentContainer from "./CheckoutComponentAlignmentContainer";

const CheckoutComponentImage: React.FC<CheckoutComponentImageAttibutesType> = ({
  alignment,
  image,
  redirectUrl,
}) => {
  const { preview } = useImagePreview({
    image,
  });

  const Image = (
    <img
      src={preview}
      alt={image?.id}
      className="w-full h-full object-cover rounded-md"
    />
  );

  return (
    <CheckoutComponentAlignmentContainer alignment={alignment}>
      {redirectUrl ? (
        <Link to={redirectUrl} target="_blank" rel="noopener noreferrer">
          {Image}
        </Link>
      ) : (
        <>{Image}</>
      )}
    </CheckoutComponentAlignmentContainer>
  );
};

export default CheckoutComponentImage;
